import React, { useState, useEffect } from 'react';
import { Image, Spin } from 'antd';
import GroceryIcon from './GroceryIcon';
import { getImageUrl } from '../SafeImage';

/**
 * Reusable table image thumbnail.
 * Usage: <TableImage src={record.imageUrl} alt="product" />
 */
const TableImage = ({ src, alt = '', size = 48, radius = 8 }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [src]);

    const finalSrc = getImageUrl(src);

    if (!finalSrc || hasError) {
        return (
            <div
                style={{
                    width: size,
                    height: size,
                    minWidth: size,
                    borderRadius: radius,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    border: '1px solid #cbd5e1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)'
                }}
            >
                <GroceryIcon size={Math.round(size * 0.7)} />
            </div>
        );
    }

    return (
        <Image
            src={finalSrc}
            alt={alt}
            width={size}
            height={size}
            loading="lazy"
            preview={false}
            placeholder={
                <div style={{
                    width: size,
                    height: size,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f8fafc',
                    borderRadius: radius,
                    border: '1px solid #e2e8f0'
                }}>
                    <Spin size="small" />
                </div>
            }
            style={{
                minWidth: size,
                borderRadius: radius,
                border: '1px solid #e2e8f0',
                display: 'block',
                objectFit: 'cover'
            }}
            onError={() => setHasError(true)}
        />
    );
};

export default TableImage;
